// COVID-19 BCP HELPER
import _isEmpty from 'lodash/isEmpty';
import Page from './page';
import { modalChannels } from '../contactUs/constants/UtilVariables';
import UrlResources from '../home/constants/UrlResources';
import { isC2MerchantMigrated } from './globalHelper';
// Get Remote config COVID BCP config from window
const getCovidConfig = () => {
  try {
    if (window && window.covidBcpConfig) {
      return window.covidBcpConfig;
    }
    return {};
  } catch (e) {
    return {};
  }
};

// Get EBS customer priority object from window.
const getEBSCustomerPriority = () => {
  try {
    if (window && window.cust_priority_info) {
      return window.cust_priority_info;
    }
    return {};
  } catch (e) {
    return {};
  }
};

export const isTrackersEnabledInHome = () => {
  const config = getCovidConfig();
  if (!_isEmpty(config)) {
    return (config.enableTrackersInHome || false);
  }
  return false;
};

export const isPopUpWindowAlertEnabled = () => {
  const config = getCovidConfig();
  if (!_isEmpty(config)) {
    return (config.popUpWindowAlert || false);
  }
  return false;
};

// KILL SWITCH to kill suppressing call US globally
const isSuppressCallUsKillSwitch = () => {
  const covidRemoteConfig = getCovidConfig();
  if (!_isEmpty(covidRemoteConfig)) {
    return (covidRemoteConfig.suppressCallUs || false);
  }
  return false;
};

// Check if current locale is COVID BCP affected.
export const isMarketLocaleCovidAffected = () => {
  const country = (Page.getCountry()).toUpperCase();
  const locale = Page.getAPILocalilty();
  const covidRemoteConfig = getCovidConfig();

  if (!_isEmpty(covidRemoteConfig)) {
    if (covidRemoteConfig.covidEffectedLocales) {
      return covidRemoteConfig.covidEffectedLocales.split(',')
        .filter((market) => market.indexOf(`${country}:`) >= 0)
        .filter((selectedMarket) => selectedMarket.split(':')[1].indexOf(locale) >= 0)
        .length > 0;
    }
  }
  return false;
};

/**
 *  Check customer priority level.
 *  If customer is hig priority dispay call US if not supress call us.
 *  customer EBS values are externalized and can be configured in remote config.
 * @returns {boolean}
 */
const isHighPriorityCustomer = () => {
  const customerPriorityInfo = getEBSCustomerPriority();
  const covidRemoteConfig = getCovidConfig();
  if (!_isEmpty(customerPriorityInfo) && !_isEmpty(covidRemoteConfig) && covidRemoteConfig.ebsPriorityLevels && customerPriorityInfo.priority_reason) {
    const rcEbsPriorityLevels = covidRemoteConfig.ebsPriorityLevels;
    return Array.isArray(rcEbsPriorityLevels) && rcEbsPriorityLevels.indexOf(customerPriorityInfo.priority_reason) >= 0;
  }
  return false;
};

/**
 *  Single function to check we need suppress call Us option or not.
 * @returns {boolean}
 */
export const isSuppressCallUs = () => {
  // Exception is for C2 Migrated Merchants and don't filter the contact-options ( configired in Remote config )
  if (isC2MerchantMigrated()) return false;
  // Root kill switch callUs check. only if supressCallUs is set to true then check of other conditions if not return false
  // and fallback to old behaviour
  if (!isSuppressCallUsKillSwitch()) {
    return false;
  }

  // If market/locale is part of remote config then check if customer is high engaged
  // If high engaged customer display call us if not suppress call us.
  if (isMarketLocaleCovidAffected()) {
    return !isHighPriorityCustomer();
  }

  // default set to false.
  return false;
};

/**
 *  This is to suppress guest call us link in logged out to login in modal window.
 *  If market/locale is part of remote config suppress guest link.
 * @returns {boolean}
 */
export const isSuppressGuestCallUsLink = () => {
  // If not  in contact us page show guest link for callus modal
  if (!Page.isContactUsPage()) {
    return false;
  }

  if (!isSuppressCallUsKillSwitch()) {
    return false;
  }

  return isMarketLocaleCovidAffected();
};

// Check if callUs channel is part of IDI response.
export const isCallUsPartOfIdi = (idiContactChannels = []) => {
  if (Array.isArray(idiContactChannels) && idiContactChannels.length) {
    const foundChannel = idiContactChannels.find((channel) => channel.type === (modalChannels.call).toLowerCase());
    return !!(foundChannel && typeof foundChannel === 'object');
  }
  return false;
};

// Returns filtered contact channels by removing callUs from list.
export const filterCallUsFromChannels = (contactChannels = []) => {
  if (Array.isArray(contactChannels) && contactChannels.length) {
    return contactChannels.filter((channel) => channel.type !== (modalChannels.call).toLowerCase());
  }
  return contactChannels;
};

/**
 * Checking in session to check whether alert popup is clicked
 */
export const isAlertPopUpClicked = () => (window.sessionStorage && sessionStorage.getItem('isAlertPopUpClicked') === 'true');

/**
 * Changing alert popup session variable when alert is clicked
 */
export const setAlertPopUpClickInSession = (value = true) => {
  sessionStorage.setItem('isAlertPopUpClicked', value);
};

/**
 * To get the page name where we are displaying the alert
 */
export const renderPopUpFpti = (pathName) => {
  if (pathName) {
    if (pathName === `/${UrlResources.HOME}`) {
      return 'homeAlertPopup';
    } if (pathName.includes(`/${UrlResources.ARTICLE}`)) {
      return 'articleAlertPopup';
    } if (pathName.includes(`/${UrlResources.TOPIC}`)) {
      return 'topicAlertPopup';
    } if (pathName === `/${UrlResources.SEARCH}`) {
      return 'searchAlertPopup';
    } if (pathName === `/${UrlResources.PAYPALGUIDE}`) {
      return 'ICFTopicAlertPopup';
    } if (pathName !== `/${UrlResources.PAYPALGUIDE}` && pathName.includes(`/${UrlResources.PAYPALGUIDE}`)) {
      return 'ICFPageAlertPopup';
    }
  }
  return '';
};
